module.exports = __webpack_public_path__ + "static/plain-pearl-cuff-hoop-190686c5724bb71d54087a89d3842eaf.jpg";